module.exports = __webpack_public_path__ + "img/loans-compare.7ad1cf7.png";